export const devname = {};

export default devname;
